module.exports = __webpack_public_path__ + "img/tuyau_3.cf6ddcc9.svg";